import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import QRCode from 'react-qr-code';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { IconButton } from '@mui/material';
import { useSelector } from 'react-redux';
const PaymentQrComponent = ({label,bankAccount,payeeName,amount,onClick,qrOpen=false,setCustomerDisplayQRInfo=()=>{}}) => {
  
  const decimalPosition=localStorage.getItem('decimalPosition')
  const { receiptData } = useSelector((state) => state.viewOrdersBillingSlice);
  const {currencyDetails}=useSelector((state)=>state.mainDashBoardSlice)
  
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
    onClick()
  };

  const handleClose = () => {
    setOpen(false);
    setCustomerDisplayQRInfo((prevState)=>({...prevState,open:false}))
  };
  const qrData = `upi://pay?pa=${bankAccount}&pn=${encodeURIComponent(payeeName)}&am=${amount}&cu=INR`;

  return (
    <div>
      <IconButton onClick={handleClickOpen} style={{backgroundColor:"#1605bc",height:"30px",width:"30px"}} aria-label='Show payment QR code'>
        <QrCode2Icon sx={{width:"16px",height:"16px",color:'#fff'}} />
      </IconButton>

      <Dialog open={open || qrOpen} onClose={handleClose} fullWidth style={{textAlign:"center"}}>
        <DialogTitle fontSize={"24px"}>{label || "Scan to Pay via UPI"}</DialogTitle>
        <DialogContent>
          <QRCode value={qrData || "eyeterp.com"} size={200} />
        </DialogContent>
        {
          
        qrOpen  ?
        <div class="price-breakdown-container" style={{marginBottom:"30px"}}>
          <h2>Order Summary</h2>
          <div class="price-details">
            <div class="price-item">
              <span>PAX:</span>
              <span>{receiptData?.orderInfo?.length}</span>
            </div>
            <div class="price-item">
              <span>Taxable amount:</span>
              <span>{currencyDetails?.symbol || ""}&nbsp;{(receiptData?.taxableAmt || 0)?.toFixed(decimalPosition)}</span>
            </div>
            {
              receiptData?.taxDetails &&
              receiptData?.taxDetails?.map((item, i) => (
                <div class="price-item" key={i}>
                  <span>{item?.taxName || ""}</span>
                  <span>{currencyDetails?.symbol || ""}&nbsp;{(item?.amount || 0)?.toFixed(decimalPosition)}</span>
                </div>
              ))
            }
            {
              receiptData?.pkgCharge > 0 &&
              <div class="price-item">
                <span>Packaging Charge:</span>
                <span>{currencyDetails?.symbol || ""}&nbsp;{(receiptData?.pkgCharge || 0)?.toFixed(decimalPosition)}</span>
              </div>}
            <div class="price-item total">
              <span>Total:</span>
              <span>{currencyDetails?.symbol || ""}&nbsp;{(receiptData?.amtTotal || 0)?.toFixed(decimalPosition)}</span>
            </div>
          </div>
        </div> :
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Done
          </Button>
        </DialogActions>}
      </Dialog>
    </div>
  );
};

export default PaymentQrComponent;